import React, { useState, useEffect } from "react";
import { Row, Card, CardTitle, Form, Label, Input, Button } from "reactstrap";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { loginUser } from "../../redux/actions";
import { Colxx } from "../../components/common/CustomBootstrap";
import IntlMessages from "../../helpers/IntlMessages";
import { NotificatioErrController } from "../../helpers/Utils";

// Detect Electron environment
const isElectron = !!window.electronAPI;

const Login = (props) => {
  // For Web: get domain from URL subdomain
  // For Electron: will use username as domain
  const getInitialDomain = () => {
    if (isElectron) {
      return ""; // Will be set from username
    }
    return window.location.host.split(".")[0];
  };

  const getInitialStoreDomain = () => {
    if (isElectron) {
      return (
        localStorage.getItem("vmass_store_domain") ||
        localStorage.getItem("domain") ||
        ""
      );
    }
    return "";
  };

  const initialStore = getInitialStoreDomain();
  const [isChangingStore, setIsChangingStore] = useState(!initialStore);

  const [values, setValues] = useState({
    username: "",
    password: "",
    domain: getInitialDomain(),
    storeDomain: initialStore, // Electron: tên cửa hàng cho nhân viên đăng nhập
  });

  useEffect(() => {
    let domain = isElectron
      ? values.domain
      : window.location.host.split(".")[0];
    if (domain === "demo") {
      setValues((v) => ({
        ...v,
        username: "demo",
        password: "quangthanh",
        domain: "demo",
      }));
    }
  }, []);

  const onUserLogin = () => {
    if (values.username !== "" && values.password !== "") {
      // For Electron:
      // - Nếu storeDomain có giá trị → nhân viên đăng nhập (domain = storeDomain)
      // - Nếu storeDomain rỗng → chủ cửa hàng (domain = username)
      const electronDomain = values.storeDomain.trim()
        ? values.storeDomain.trim().toLowerCase()
        : values.username.toLowerCase();

      const loginValues = isElectron
        ? { ...values, domain: electronDomain }
        : values;

      // Save domain to localStorage for Electron
      if (isElectron) {
        localStorage.setItem("vmass_store_domain", electronDomain);
        localStorage.setItem("domain", electronDomain);
      }
      props.loginUser(loginValues, props.history);
    } else {
      NotificatioErrController("Điền đầy đủ thông tin");
      return false;
    }
  };

  const onChangeHandleInput = (e) => {
    const { value, name } = e.target;
    setValues({ ...values, [name]: value });
  };

  const onChangeHandleKeyPress = (e) => {
    if (e.key === "Enter") {
      onUserLogin();
    }
  };

  useEffect(() => {
    if (props.user && typeof props.user === "object" && props.user.status && props.user.status !== 200) {
      const errorMsg =
        props.user.data?.responseText ||
        props.user.data?.message ||
        props.user.responseText ||
        props.user.message ||
        "Đăng nhập không thành công";
      NotificatioErrController(errorMsg);
    }
  }, [props.user]);

  return (
    <Row className="h-100">
      <Colxx xxs="12" md="10" className="mx-auto my-auto">
        <Card className="auth-card" autoFocus={false}>
          <div
            className="position-relative image-side "
            style={{
              backgroundImage: `url('${process.env.PUBLIC_URL}/assets/img/login-balloon.jpg')`,
            }}
          >
            <p className="text-white h2">ĐĂNG NHẬP</p>
            <p className="white mb-0">
              Đăng nhập hệ thống.
              <br />
              {isElectron ? (
                <small className="text-white-50">Phiên bản Desktop</small>
              ) : (
                ""
              )}
            </p>
          </div>
          <div className="form-side">
            <a href="https://vmass.vn/" className="white">
              <span
                className="logo-single"
                style={{
                  backgroundImage: `url('${process.env.PUBLIC_URL}/assets/img/logo-black.svg')`,
                }}
              />
            </a>
            <CardTitle className="mb-4">
              <IntlMessages id="user.login-title" />
            </CardTitle>
            <Form autoComplete="off">
              {isElectron && values.storeDomain && !isChangingStore ? (
                <div
                  className="d-flex align-items-center justify-content-between p-2 px-3 mb-4 rounded"
                  style={{
                    backgroundColor: "#f4f7fb",
                    border: "1px solid #dce5ef",
                  }}
                >
                  <div className="d-flex align-items-center text-truncate mr-2">
                    <i
                      className="iconsminds-shop-4 text-primary mr-2"
                      style={{ fontSize: "1.3rem" }}
                    />
                    <div className="text-truncate">
                      <div
                        className="text-muted text-uppercase font-weight-bold"
                        style={{ fontSize: "0.65rem", letterSpacing: "0.5px" }}
                      >
                        Cửa hàng
                      </div>
                      <div
                        className="font-weight-bold text-dark text-truncate"
                        style={{ fontSize: "0.95rem" }}
                      >
                        {values.storeDomain}
                      </div>
                    </div>
                  </div>
                  <Button
                    color="link"
                    size="sm"
                    className="p-0 text-primary font-weight-bold"
                    style={{
                      fontSize: "0.85rem",
                      textDecoration: "none",
                      whiteSpace: "nowrap",
                    }}
                    onClick={() => setIsChangingStore(true)}
                  >
                    Đổi cửa hàng
                  </Button>
                </div>
              ) : isElectron ? (
                <div className="position-relative mb-4">
                  <Label className="form-group has-float-label mb-1 w-100">
                    <Input
                      autoFocus={true}
                      type="text"
                      onChange={onChangeHandleInput}
                      onKeyPress={onChangeHandleKeyPress}
                      name="storeDomain"
                      value={values.storeDomain}
                      autoComplete="off"
                      placeholder="Ví dụ: quanan123"
                    />
                    <span>
                      Tên cửa hàng{" "}
                      <small className="text-muted">
                        (tự động lưu trên thiết bị)
                      </small>
                    </span>
                  </Label>
                  {initialStore ? (
                    <Button
                      color="link"
                      size="sm"
                      className="p-0 text-muted"
                      style={{ fontSize: "0.8rem", textDecoration: "none" }}
                      onClick={() => {
                        setValues((prev) => ({
                          ...prev,
                          storeDomain: initialStore,
                        }));
                        setIsChangingStore(false);
                      }}
                    >
                      ← Giữ lại "{initialStore}"
                    </Button>
                  ) : null}
                </div>
              ) : null}
              <Label className="form-group has-float-label mb-4">
                <Input
                  autoFocus={
                    !isElectron || (!isChangingStore && !!values.storeDomain)
                  }
                  type="text"
                  onChange={onChangeHandleInput}
                  onKeyPress={onChangeHandleKeyPress}
                  name="username"
                  defaultValue={values.username}
                  autoComplete="off"
                />
                <IntlMessages id="user.username" />
              </Label>
              <Label className="form-group has-float-label mb-4">
                <Input
                  type="password"
                  name="password"
                  onChange={onChangeHandleInput}
                  onKeyPress={onChangeHandleKeyPress}
                  defaultValue={values.password}
                  autoComplete="new-password"
                />
                <IntlMessages id="user.password" />
              </Label>
              <div className="d-flex justify-content-between align-items-center">
                <NavLink to={`/user/forgot-password`}>
                  <IntlMessages id="user.forgot-password-question" />
                </NavLink>
                <Button
                  color="primary"
                  className="btn-shadow"
                  size="lg"
                  onClick={onUserLogin}
                >
                  <IntlMessages id="user.login-button" />
                </Button>
              </div>
              <div className="d-flex justify-content-center align-items-center mt-4">
                <span className="text-muted mr-1">
                  <IntlMessages id="user.no-account" />
                </span>
                {isElectron ? (
                  <a
                    href="#"
                    className="font-weight-bold"
                    onClick={(e) => {
                      e.preventDefault();
                      window.open("https://register.vmass.vn/user/register");
                    }}
                  >
                    <IntlMessages id="user.register-link" />
                  </a>
                ) : (
                  <a
                    href={`${window.location.protocol}//${(() => {
                      const host = window.location.host;
                      const parts = host.split(".");
                      if (host.includes("localhost")) {
                        return parts.length > 1
                          ? "register." + parts.slice(1).join(".")
                          : "register." + host;
                      }
                      return parts.length > 2
                        ? "register." + parts.slice(1).join(".")
                        : "register." + host;
                    })()}/user/register`}
                    className="font-weight-bold"
                  >
                    <IntlMessages id="user.register-link" />
                  </a>
                )}
              </div>
            </Form>
          </div>
        </Card>
      </Colxx>
    </Row>
  );
};
const mapStateToProps = ({ authUser }) => {
  const { user, loading } = authUser;
  return { user, loading };
};

export default connect(mapStateToProps, {
  loginUser,
})(Login);
